import React from 'react'

interface PercentChangeBadgeProps {
  value: number
  label?: string
  size?: 'sm' | 'md'
}

export default function PercentChangeBadge({
  value,
  label = 'vs Previous Month',
  size = 'md',
}: PercentChangeBadgeProps) {
  const isPositive = value > 0
  const isNeutral = value === 0

  const bgColor = isNeutral ? 'bg-gray-100' : isPositive ? 'bg-green-50' : 'bg-red-50'
  const textColor = isNeutral ? 'text-gray-600' : isPositive ? 'text-green-700' : 'text-red-700'
  const arrow = isNeutral ? '–' : isPositive ? '↑' : '↓'

  const textSize = size === 'sm' ? 'text-xs' : 'text-sm'
  const padding = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1'

  return (
    <span
      className={`inline-flex items-center ${padding} rounded-full ${bgColor} ${textColor} ${textSize} font-medium`}
    >
      {arrow} {Math.abs(value)}% <span className="text-gray-500 font-normal ml-1">{label}</span>
    </span>
  )
}
